import { sellTicketStatusInversed } from '@teinor/erp/types/company/order/sell/sellTicket'
import { cleanTableDataForOriginalTable, groupTableDataByAddonParent, addErrorsOfTableDataInHeader, addInventPositionToOrderData, parseScalesOfOrderData } from '../../../../../specificComponents/inputTableLayouts/order/OrderLayout/useOrderScreenLogic/functions'
import { handleSellTicketRefundData } from '../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/functions'
import { TPVOrderData } from '../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { recalculateAllQuoteOrderRows } from '@teinor/erp/prices/quote/calculate'
import { UserModel } from '../../../../../utils/reducers/globals/user'
import { TPVWorkingCenterInfoTy } from './types'

export const parsedTicketTableData = (orderData: TPVOrderData, addRefundInfo?: boolean, updateLastProduct?: boolean ) => {
    if (!orderData.header) {
        orderData.header = {}
    }
    orderData.originalTableData = cleanTableDataForOriginalTable(orderData.tableData || [])
    orderData.tableData = groupTableDataByAddonParent(orderData.tableData)
    if (addRefundInfo) {
        orderData.tableData = handleSellTicketRefundData(orderData.tableData)
        orderData.discountsWithVat = true
        recalculateAllQuoteOrderRows(orderData)
    }
    orderData = addErrorsOfTableDataInHeader(orderData) as any
    orderData = addInventPositionToOrderData(orderData) as any
    orderData = parseScalesOfOrderData(orderData) as any
    const readOnly = ((orderData?.header?.status !== sellTicketStatusInversed['creating'] && orderData?.header?.status !== sellTicketStatusInversed['saved']) || orderData?.header?.notModificable || orderData?.header?.SellTicketId) ? true : false
    orderData.header['readOnly'] = readOnly
    if (!readOnly || (!orderData?.header?.status && orderData?.cashRegister?.id)) {
        orderData.tableData.push({ type: 'addButton', id: 'addButton' })
    }
    let processedTableLength = 0
    orderData.dictPosTableData = {}
    for (const key in orderData.tableData) {
        const element = orderData.tableData[key]
        if (element.id && element.type !== 'addButton' && ((element.type === 'productCombinedHeaderAddon' && element.OrderAddonGroupId && !element.OrderProductId) || (element.type !== 'productCombinedHeader' && element.OrderVariantGroupId && !element.OrderAddonGroupId ) || (!element.OrderAddonGroupId && !element.OrderVariantGroupId)) && updateLastProduct) {
            orderData.lastProductIndex = parseInt(key)
        }
        if (element.processed) {
            processedTableLength++
        }
        const myParsedKey = parseInt(key)
        element.absoluteIndex = myParsedKey
        orderData.dictPosTableData[element.id] = myParsedKey
    }
    orderData.processedTableLength = processedTableLength
    orderData.discountsWithVat = true
    return orderData
}

type MultiProductsToProcessingTy = {
    products: TwinDictionary[]
}
export interface MultiSelectedTableForProcessingTy {
    forSend: MultiProductsToProcessingTy
}

export const parseSellTicketRefundSelectedTableForProcessing = (completeData: TPVOrderData) => {
    const parsedData: TPVOrderData = JSON.parse(JSON.stringify(completeData))
    const myTableData = parsedData?.selectedTableData || []
    const result: MultiSelectedTableForProcessingTy = {
        forSend: {
            products: []
        }
    }
    for (const element of myTableData) {
        let myElement = element
        if (parsedData?.dictPosTableData?.[myElement.id] !== undefined) {
            myElement = parsedData?.tableData[parsedData?.dictPosTableData?.[myElement.id]]
        }
        if (!myElement.processed && myElement.OrderId && myElement?.type !== "addButton") {
            const quantity = parseFloat(myElement.quantity)
            if (quantity > 0) {
                result.forSend.products.push({ id: myElement.id, OrderId: myElement.OrderId, quantity: myElement.quantity, returnStock: myElement?.returnStock, unique_number: myElement?.unique_number_selected?.length ? myElement?.unique_number_selected : myElement?.unique_number, WarehouseId: myElement.WarehouseId, quantity2: myElement?.quantity2})
            }
        }
    }
    return result
}

export const getTPVWorkingCenterAndStep = (EmployeeWorkingCenterId?: number, EmployeeWorkingCenterStation?: number, user?: UserModel) => {
    let myWorkingCenterId = EmployeeWorkingCenterId ? String(EmployeeWorkingCenterId) : undefined
    let myWorkingCenterStationId = EmployeeWorkingCenterStation ? String(EmployeeWorkingCenterStation) : undefined
    if (!user?.WorkingCenters?.[parseInt(myWorkingCenterId || '0')]) {
        myWorkingCenterId = ''
        myWorkingCenterStationId = ''
    }
    if (user?.WorkingCenters) {
        const workingCenterLength = Object.keys(user?.WorkingCenters).length
        const mySelectedWorkingCenterId = parseInt(String(myWorkingCenterId || user.WorkingCenterId || user.WorkingCenters?.[0]?.id))
        const mySelectedWorkingCenterStations = user.WorkingCenters?.[mySelectedWorkingCenterId]?.WorkingCenterStations
        const workingCenterStationsLength = mySelectedWorkingCenterStations?.length || 0
        const mySelectedWorkingCenterStationId = workingCenterStationsLength ? parseInt(String(myWorkingCenterStationId || user.WorkingCenterStationId || mySelectedWorkingCenterStations?.[0]?.id || 0)) : 0
        let step: TPVWorkingCenterInfoTy['step'] = 'checkCashRegister'
        if ((!myWorkingCenterId && workingCenterLength > 1) || (!myWorkingCenterStationId && workingCenterStationsLength > 1)) {
            step = 'askWorkingCenter'
        }
        if (!workingCenterLength) {
            step = 'noWorkingCenter'
        }
        return {
            MyWorkingCenterId: mySelectedWorkingCenterId,
            MyWorkingCenterStationId: mySelectedWorkingCenterStationId,
            step
        }
    }
    return null
}